angular.module('gym.pos').factory('TaxRates', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('pos').all('tax_rates');
}]);
